import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWaveform = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M3 16.5h2v.5h-2l0 -.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 16.5h2.5v.5h-2.5l0 -.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 17h-2.5v-.5h2.5l0 .5" }),
		/* @__PURE__ */ _jsx("path", { d: "M21.5 17h-2.5v-.5h2.5l0 .5" }),
		/* @__PURE__ */ _jsx("path", { d: "M21.5 13h-2.5v.5h2.5l0 -.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M21.5 9.5h-2.5v.5h2.5l0 -.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M21.5 6h-2.5v.5h2.5l0 -.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 13h-2.5v.5h2.5l0 -.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 13.5h2.5v-.5h-2.5l0 .5" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 9.5h2.5v.5h-2.5l0 -.5" })
	]
});
export default SvgWaveform;
